/* 🤖 this file was generated by svg-to-ts */
export const emperorIconRedo: {
  name: 'redo';
  data: string;
} = {
  name: 'redo',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M18.96 13c-.12 1.327-.62 2.54-1.37 3.55l1.42 1.42c1.1-1.39 1.81-3.11 1.94-4.98h-2Z"/><path d="M13 19.29v2.02c1.73-.2 3.31-.88 4.61-1.92l-1.43-1.43c-.92.68-2.01 1.15-3.19 1.32Z"/><path d="M20.88 11c-.27-1.7-1-3.29-2.14-4.584l-1.5 1.32c.82.93 1.37 2.058 1.61 3.26h2.02Z"/><path d="M7.47 4.6C4.8 6.16 2.99 9.05 2.99 12.36c0 4.62 3.5 8.44 8 8.94v-2.02c-3.39-.49-6-3.401-6-6.92 0-2.75 1.59-5.12 3.89-6.266l3.1 3.26V1.98h-7l2.47 2.6Z"/></g></svg>`,
};
